export type SupportedLanguage = 'it' | 'en'
const supportedLanguages: SupportedLanguage[] = ['it', 'en']
export function isSupportedLanguage(language: string): language is SupportedLanguage {
  return supportedLanguages.includes(language as SupportedLanguage)
}
